export default __webpack_public_path__ + "static/media/matrix-pepe.78bb1b54.jpeg";